import { defineStore } from 'pinia';
import type { BürgeAnzeigedaten as BuergeAnzeigedaten } from '@/types/Partner';
import { useSharedApi } from '@/shared/api/useSharedApi.ts';
import { useBuergenStore } from '@/shared/Buergen/useBuergenStore.ts';

interface StoreState {
  anzeigeDatenCache: Record<string, BuergeAnzeigedaten>;
}

export const useBuergenAnzeigedatenStore = defineStore('BuergenAnzeigedatenStore', {
  state: (): StoreState => ({
    anzeigeDatenCache: {},
  }),

  actions: {
    async ladeAnzeigedaten(buergeId: string) {
      if (this.anzeigeDatenCache[buergeId] === undefined) {
        const result = await useSharedApi().sharedPartner.holeBuergeAnzeigedatenNachId(buergeId);

        this.anzeigeDatenCache[buergeId] = result;
      }

      return this.anzeigeDatenCache[buergeId];
    },

    async loadDisplayStylesBulk() {
      const result = await useSharedApi().sharedPartner.getGuarantorsDisplayStylesBulk();
      const buergenStore = useBuergenStore();

      result.forEach((item) => {
        this.anzeigeDatenCache[item.buergeId] = {
          bürge: buergenStore.getBuergeById(item.buergeId),
          cssHeaderFontColor: item.cssHeaderFontColor,
          cssHeaderColor: item.cssHeaderColor,
        };
      });
    },
  },

  getters: {
    holeAnzeigedaten(state): (buergeId: string) => undefined | BuergeAnzeigedaten {
      return (buergeId: string): undefined | BuergeAnzeigedaten =>
        state.anzeigeDatenCache[buergeId];
    },
  },
});
